import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/Home.vue'
import ServicesView from '../views/Services.vue'
import LoginView from '../views/Login.vue'
import SignupView from '../views/Signup.vue'
import ProfileView from '../views/Profile.vue'
import InstrumentsView from '../views/Products/Instruments.vue'
import BlackBooksView from '../views/Products/BlackBooks.vue'
import PYQPapersView from '../views/Products/PYQPapers.vue'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'home',
		component: HomeView
	},
	{
		path: '/services',
		name: 'services',
		component: ServicesView,
		meta: {
			needsUser: true
		}
	},
	{
		path: '/login',
		name: 'login',
		component: LoginView
	},
	{
		path: '/signup',
		name: 'signup',
		component: SignupView
	},
	{
		path: '/profile',
		name: 'profile',
		component: ProfileView,
		meta: {
			needsUser: true
		}
	},
	{
		path: '/instruments',
		name: 'instruments',
		component: InstrumentsView,
		meta: {
			needsUser: true
		}
	},
	{
		path: '/blackbooks',
		name: 'blackbooks',
		component: BlackBooksView,
		meta: {
			needsUser: true
		}
	},
	{
		path: '/pyqpapers',
		name: 'pyqpapers',
		component: PYQPapersView,
		meta: {
			needsUser: true
		}
	}
]

const router = new VueRouter({
	mode: 'history',
	base: '',
	routes
})

router.beforeEach((to, from, next) => {
	if (to.meta.needsUser) {
		if (!localStorage.getItem('token')) {
			next('/login')
			Vue.$toast.info('Please login to start using services', {
				position: 'top'
			})
		} else next()
	} else next()
})

export default router
